import { FieldModel, PracticeContentDataTypes, PracticeDetailTypesEntry } from '@cibo/core'
import { ListCell } from '@cibo/ui'
import { GridRenderCellParams } from '@mui/x-data-grid-pro'
import { Dispatch, SetStateAction } from 'react'
import { useField, usePracticesInformation } from '../../queries'

export const PracticesSelectedCell = ({
  params,
  setHighPractices,
}: {
  params: GridRenderCellParams<string, FieldModel>
  setHighPractices?: Dispatch<SetStateAction<string[]>>
}) => {
  const field = useField(params.row.id)
  const { data, isLoading } = usePracticesInformation()
  const selectedPractices = field.data?.resolveStandingDetail('eqipSelectedPractices')?.result

  if (setHighPractices && selectedPractices && selectedPractices.length >= 5) {
    setHighPractices((prevState: string[]) => {
      if (prevState && !prevState.includes(params.row.name.toString())) {
        return [...prevState, params.row.name.toString()]
      }
      return prevState
    })
  }

  const currentPractices = data?.items.filter(
    (practice: PracticeContentDataTypes) =>
      selectedPractices && selectedPractices.includes(practice.fields.practiceId)
  )
  return (
    <ListCell<PracticeDetailTypesEntry>
      isLoading={isLoading}
      listItems={currentPractices}
      accessor={(practice: PracticeContentDataTypes) => practice.fields.name}
    />
  )
}
